import * as tools from "@/utils/tool";

export default {}.install = (Vue) => {
  for (let f in tools) {
    Vue.filter(f, tools[f]);
  }
};
